import createLucideIcon from '../createLucideIcon';

const ArrowLeftCircle = createLucideIcon('ArrowLeftCircle', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['polyline', { points: '12 8 8 12 12 16', key: 'bz1698' }],
  ['line', { x1: '16', x2: '8', y1: '12', y2: '12', key: '1ckucc' }],
]);

export default ArrowLeftCircle;
